import React, { useEffect, useState, useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import OpenInNewSharpIcon from '@mui/icons-material/OpenInNewSharp';
import ReactTable from 'components/common/ReactTable';
import { useForm, Controller } from 'react-hook-form';
import SearchableDropdown from 'components/common/SearchableDropdown';
import ReactDatePicker from 'components/common/ReactDatePicker';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { checkModulePermission } from 'components/common/helper-function/ModulePermissionCheck';
import './report.css'
import { listidenti } from 'services/manageEventsService'
import { getListOfDepartment } from 'services/adminmoduleService'
import { errorMessage } from 'components/common/helper-function/catchErrorMessage';
import { visithoursreportlist } from 'services/reportsService'
import { loaderContext } from 'context/Context';
import moment from 'moment';




function VisitHoursExceededReport() {

    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    const { isLoading, setIsLoading } = useContext(loaderContext)

    const { t } = useTranslation();
    const navigate = useNavigate();
    const [visithourexceededdata, setVisitHourExceededData] = useState([]);

    const [visitoridOption, setVisitorIdOption] = useState([]);
    const [departmentOption, setDepartmentOption] = useState([]);

    // const [dateRange, setDateRange] = useState([null, null]);
    // const [startDate, endDate] = dateRange;

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);


    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
        control,
        setValue,
        setError,
        clearErrors,
        watch
    } = useForm();

    useEffect(async () => {
        checkModulePermission("Visit Hours Exceeded")
        setIsLoading(true)
        try {
            const { data: visitorid } = await listidenti()
            const { data: department } = await getListOfDepartment()
            const { data: visithour } = await visithoursreportlist({})
            setDepartmentOption(department?.data?.map((dep) => ({ label: dep?.name, value: dep?.id })))
            setVisitorIdOption(visitorid?.data?.map((visit) => ({ label: visit?.name, value: visit?.id })))
            setVisitHourExceededData(visithour?.data)
        } catch (error) {
            errorMessage(error)
        }
        setIsLoading(false)
    }, [])

    const columns = [

        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.visitorname'),
            accessor: 'name',
            Cell: ({ row }) => {
                return row?.original?.name ? row?.original?.name : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.mobileno'),
            accessor: 'phone_number',
            Cell: ({ row }) => {
                return row?.original?.phone_number ? `${row?.original?.country_code}-${row?.original?.phone_number}` : '--'
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.visitorid'),
            accessor: 'document_id_number',
            Cell: ({ row }) => {
                return row?.original?.document_id_number ? row?.original?.document_id_number : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.idtype'),
            accessor: 'document_id_type',
            Cell: ({ row }) => {
                return row?.original?.document_id_type ? row?.original?.document_id_type : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.accesscardno'),
            accessor: 'access_card_no',
            Cell: ({ row }) => {
                return row?.original?.access_card_no ? row?.original?.access_card_no : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.department'),
            accessor: 'department_name',
            Cell: ({ row }) => {
                return row?.original?.department_name ? row?.original?.department_name : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.host'),
            accessor: 'host_name',
            Cell: ({ row }) => {
                return row?.original?.host_name ? row?.original?.host_name : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.timein'),
            accessor: 'time_in',
            Cell: ({ row }) => {
                return row?.original?.time_in ? moment.utc(row?.original?.time_in).local().format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.timeout'),
            accessor: 'time_out',
            Cell: ({ row }) => {
                return row?.original?.time_out ? moment.utc(row?.original?.time_out).local().format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : "--"
            }
        },
        {
            Header: t('visithoursexceededreport.visithoursexceededreporttable.status'),
            accessor: 'status',
            Cell: ({ row }) => (
                <>
                    {row.original.status === "1" ? (
                        <div style={{ backgroundColor: "#E0E0E0", color: "#424242", borderRadius: "3px", border: "1px solid #E0E0E0", fontWeight: "bold", margin: "0rem 0rem" }}> {t('visithoursexceededreport.loggedout')}</div>
                    ) : <div
                        style={{
                            backgroundColor: "pink",
                            color: "red",
                            border: "1px solid pink",
                            borderRadius: "3px"
                        }}
                    >
                        {t('visithoursexceededreport.notloggedout')}
                    </div>
                    }
                </>
            ),
        },
    ];

    const onSubmit = async (data) => {
        setIsLoading(true)
        if (data?.department_id || data?.visitor_id_type || (startDate && endDate)) {
            try {
                data.department_id = data?.department_id?.value
                data.visitor_id_type = data?.visitor_id_type?.value
                if (startDate && endDate) {
                    data.date_range = `${moment(startDate).format(process.env.REACT_APP_FILTER_DATE)}-${moment(endDate).format(process.env.REACT_APP_FILTER_DATE)}`;
                }
                const { data: visithour } = await visithoursreportlist(data)
                setVisitHourExceededData(visithour?.data)
            } catch (error) {
                errorMessage(error)
            }
        }

        setIsLoading(false)
    };

    const downloadPDF = () => {
        const docDefinition = {
            pageOrientation: 'landscape',
            pageSize: { width: 800, height: 600 },
            content: [
                { text: 'User Data', style: 'header' },
                { text: '\n' },
                {
                    table: {
                        headerRows: 1,
                        widths: Array.from({ length: columns.length }, () => 'auto'),
                        body: [
                            columns.map((column) => column.Header),
                            ...visithourexceededdata.map((row) => columns.map((column) => {
                                if (column.accessor === 'time_in' || column.accessor === 'time_out') {
                                    return row[column.accessor] && row[column.accessor] !== "" ? moment.utc(row[column.accessor]).local().format(process.env.REACT_APP_SET_DATE_TIME_FORMAT) : '--';
                                } else if (column.accessor === 'phone_number') {
                                    const phoneNumber = row['phone_number'];
                                    const countryCode = row['country_code'];
                                    return phoneNumber && phoneNumber !== "" ? `${countryCode} ${phoneNumber}` : '--';
                                } else if (column.accessor === 'status') {
                                    return row[column.accessor] === 1 ? 'Not Logged Out' :
                                        row[column.accessor] === 2 ? 'Logged Out' : '';
                                } else {
                                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                                }

                            })),
                        ],
                    },
                },
            ],
            defaultStyle: {
                actionHeader: false,
            },
            styles: {
                header: {
                    fontSize: 18,
                    bold: true,
                },
            },
        };

        const pdfDocGenerator = pdfMake.createPdf(docDefinition);
        pdfDocGenerator.download('visithourexceeded_data.pdf');
    };

    const downloadCSV = () => {
        const csvData = [
            columns.map((column) => column.Header),
            ...visithourexceededdata.map((row) => columns.map((column) => {
                if (column.accessor === 'time_in' || column.accessor === 'time_out') {
                    return row[column.accessor] && row[column.accessor] !== "" ? moment.utc(row[column.accessor]).local().format(process.env.REACT_APP_TIME_FORMAT_24) : '--';
                } else if (column.accessor === 'phone_number') {
                    const phoneNumber = row['phone_number'];
                    const countryCode = row['country_code'];
                    return phoneNumber && phoneNumber !== "" ? `${countryCode} ${phoneNumber}` : '--';
                } else if (column.accessor === 'status') {
                    return row[column.accessor] === 1 ? 'Not Logged Out' :
                        row[column.accessor] === 2 ? 'Logged Out' : '';
                } else {
                    return row[column.accessor] !== undefined ? row[column.accessor] : '';
                }

            })),
        ]
            .map((row) => row.join(','))
            .join('\n');

        const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });
        saveAs(blob, 'visithourexceeded_data.csv');
    };


    return (
        <div className="row g-3 mb-3">
            {/* <div className=""> */}
            <div className="card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-9 data-table" style={{ height: "fit-content" }}>
                <div className="card-header">
                    <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-4 heading-text">
                            <h3 className="heading-color fw-600 mb-0">
                                {t('visithoursexceededreport.heading')}
                            </h3>
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-8 table-btn" >
                            <button
                                className="btn btn-primary btn-sm float-end"
                                onClick={() => downloadPDF()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('visithoursexceededreport.exportpdfbtn')}
                                </span>
                            </button>

                            <button
                                className="btn mx-1 btn-primary btn-sm float-end"
                                onClick={() => downloadCSV()}
                            >
                                <OpenInNewSharpIcon />
                                {/* <FontAwesomeIcon icon="plus" /> */}
                                <span className="ms-1 d-sm-inline ">
                                    {t('visithoursexceededreport.exportcsvbtn')}
                                </span>
                            </button>
                        </div>

                        <div className="col-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div className="card-body pt-0">
                    <ReactTable
                        columns={columns}
                        data={visithourexceededdata}
                        pageSizeOption={[5, 10, 15, 20]}
                        headerClass="btn-primary"
                        isSearchBoxVisible
                        widthClass="table-width"
                        ispaginationvisible={true}
                    />
                </div>
            </div>


            <div className='card overflow-hidden mb-3 col-sm-12 col-md-12 col-lg-2 filter-table' style={{ padding: "0rem .8rem 0rem .8rem", height: "fit-content" }}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className='row' style={{ backgroundColor: "rgb(247, 247, 247)", paddingTop: ".8rem", height: "3rem", color: "black", marginBottom: '1rem' }}>
                        <span>{t('visithoursexceededreport.filterheading')}</span>
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('visithoursexceededreport.filterform.visitoridtype')}
                        </label>
                        <Controller
                            name="visitor_id_type"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={visitoridOption}
                                    hasError={errors.visitor_id_type}
                                // placeholder={t('guestsummaryreport.placeholder.idtype')}
                                />
                            )}
                        />
                        {/* {errors.visitor_id_type && (
                            <small>
                                {errors.visitor_id_type.type === 'required' && (
                                    <span className="text-danger">
                                        {t('bypassreport.error.visitoridtype')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('visithoursexceededreport.filterform.department')}
                        </label>
                        <Controller
                            name="department_id"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <SearchableDropdown
                                    value={value}
                                    onChange={onChange}
                                    options={departmentOption}
                                    hasError={errors.department_id}
                                // placeholder={t('guestsummaryreport.placeholder.idtype')}
                                />
                            )}
                        />
                        {/* {errors.department_id && (
                            <small>
                                {errors.department_id.type === 'required' && (
                                    <span className="text-danger">
                                        {t('summaryreport.error.departmenterror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="form-group col-12 mb-3">
                        <label>
                            {t('visithoursexceededreport.filterform.date')}
                        </label>
                        <Controller
                            name="date_range"
                            control={control}
                            // rules={{ required: true }}
                            render={({ field: { value, onChange } }) => (
                                <>
                                    {/* <ReactDatePicker
                                    value={value}
                                    // onChange={onChange}
                                    onChange={(update) => {
                                        setDateRange(update);
                                    }}
                                    placeholder={t(
                                        'visithoursexceededreport.placeholder.date'
                                    )}
                                    hasErrors={errors.date_range}
                                    dateFormat="dd-MM-yyyy"
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange={true}
                                // isClearable={true}
                                /> */}

                                    <ReactDatePicker
                                        selected={startDate}
                                        value={startDate}
                                        onChange={(date) => setStartDate(date)}
                                        placeholder={t('summaryreport.placeholder.startdate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsStart
                                        startDate={startDate}
                                        endDate={endDate}
                                        maxDate={endDate || undefined}
                                    />
                                    {/* <span className="mx-2">-</span> */}
                                    <br />
                                    <ReactDatePicker
                                        selected={endDate}
                                        value={endDate}
                                        onChange={(date) => setEndDate(date)}
                                        placeholder={t('summaryreport.placeholder.enddate')}
                                        dateFormat="dd/MM/yyyy"
                                        selectsEnd
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={startDate || undefined}
                                    />
                                </>
                            )}
                        />
                        {/* {errors.date_range && (
                            <small>
                                {errors.date_range.type === 'required' && (
                                    <span className="text-danger">
                                        {t('visitsreport.error.dateerror')}
                                    </span>
                                )}
                            </small>
                        )} */}
                    </div>

                    <div className="text-start col-12">
                        <div className="mb-3 mt-4 text-start">
                            <button type="submit" className="col-lg-12 btn btn-primary me-1">
                                {t('visithoursexceededreport.filterform.filterbtn')}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
            {/* </div> */}
        </div>
    )
}

export default VisitHoursExceededReport